module.exports = __webpack_public_path__ + "static/media/Region.8294f534.svg";